angular.module('zc.commonApi')
  .factory('DashboardChartPositions', DashboardChartPositions);

DashboardChartPositions.$inject = ['$q', '$state', 'Api'];
function DashboardChartPositions($q, $state, Api) {
  const { projectId } = $state.params;
  const API_URL = `/api/projects/${projectId}/dashboard_chart_positions`;
  return {
    create,
    get,
    update,
  };

  function get() {
    return Api.get(API_URL, {}, { cache: false })
      .then(res => {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data;
      });
  }

  function create(positions) {
    return Api.post(
      API_URL,
      { positions },
      { cache: false },
    );
  }

  function update(positions) {
    return Api.patch(
      API_URL,
      { positions },
      { cache: false },
    );
  }

}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/dashboard_chart_positions.service.js